export default __webpack_public_path__ + "static/media/sort-arrow-up-active.5e356b57.svg";